import React from "react";
import {registerPassages, jumpTo} from "../../Utils";
import {addTimePart, getRandomItem} from "../features/functions";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import V from "../../features/V";
import Image from "../../features/Image";
import images, {getRandomImage} from "../images";
import places from "../places/places";
import people, {currentPlayer} from "../people/people";
import Say from "../../features/Say";
import constants from "../constants";
import conditions from "../conditions";
import variables from "../variables";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

registerPassages({
    main: <Passage>
        <V callback={()=>{
            const nextPassage = getRandomItem([
                "homeEvents.movieTime", "homeEvents.bedTime", "homeEvents.walkTime", "homeEvents.cookingTime",
                "homeEvents.dressingTime"
            ]);
            variables.game.randomEvents.homeWife = true;
            jumpTo(nextPassage);
        }}/>
    </Passage>,
    movieTime: <Passage>
        <V callback={()=>{
            if (!(conditions.isEvening() && conditions.isStartOfDayPart()))
                currentPlayer.goTo(places.homeBedroom.id)
        }}/>
        <Trans i18nKey="homeEvents.movieTime.header">1<h1/></Trans>
        <V callback={()=>{
            if (people.wife.relations <= constants.wife.relationsTo.homeEvents)
                return (
                    <div>
                        <Trans i18nKey="homeEvents.movieTime.body">
                            1<Name who={people.wife}/><Image src={images.wife.actions.movieTime.wifeWatchesAlone}/>
                            <Say who={people.player}/><Say who={people.wife}/><div style={{color: "red"}}/><br/>
                            <Link to="" callback={()=>{
                                addTimePart(true);
                                addTimePart(true);
                                currentPlayer.goTo(places.homeBedroom.id);
                            }}/>{{wife: people.wife.name}}
                        </Trans>
                    </div>
                )
            else
                jumpTo("homeEvents.movieTimeWatchTogether")
        }}/>
    </Passage>,
    movieTimeWatchTogether: <Passage>
        <Trans i18nKey="homeEvents.movieTime">
            1<h1/><Name who={people.wife}/><Say who={people.wife}/><Say who={people.player}/>
            <Image src={images.wife.actions.movieTime.watchTogether}/><Image src={images.wife.actions.movieTime.tits}/>
            <Link to="" disabled/><br/><Link to="homeEvents.movieTimeUncomfortable"/>
        </Trans>
    </Passage>,

    movieTimeUncomfortable: <Passage>
        <Trans i18nKey="homeEvents.movieTimeUncomfortable">
            1<h1/><Say who={people.player}/><Say who={people.wife}/>
            <Image src={images.wife.actions.movieTime.watchTogetherLay}/>
            <Name who={people.wife}/><br/>
            <Link to="" callback={()=>{
                addTimePart(true);
                addTimePart(true);
                currentPlayer.goTo(places.homeBedroom.id);}}/>
        </Trans>
    </Passage>,

    bedTime: <Passage>
        <Trans i18nKey="homeEvents.bedTime.header">1<h1/></Trans>
        <V callback={()=>{
            if (!(conditions.isEvening() && conditions.isStartOfDayPart()))
                currentPlayer.goTo(places.homeBedroom.id)
        }}/>
        <V callback={()=>{
            if (people.wife.relations <= constants.wife.relationsTo.homeEvents)
                return (
                    <div>
                        <Trans i18nKey="homeEvents.bedTime.body">
                            1<Name who={people.wife}/><Image src={images.wife.actions.bedTime.wifeOnBed}/>
                            <Say who={people.player}/><Say who={people.wife}/><Name who={people.wife} nickname/>
                            <div style={{color: "red"}}/><br/>
                            <Link to="" callback={()=>{
                                addTimePart(true);
                                currentPlayer.goTo(places.homeBedroom.id);}}/>{{wife: people.wife.name}}
                        </Trans>
                    </div>
                )
            else
                jumpTo("homeEvents.bedTimeTogether")
        }}/>
    </Passage>,

    bedTimeTogether: <Passage>
        <Trans i18nKey="homeEvents.bedTimeTogether">
            1<h1/><Name who={people.wife}/><Say who={people.wife}/><Say who={people.player}/>
            <Image src={images.wife.actions.bedTime.couple}/>
            <Image src={getRandomImage(images.wife.actions.bedTime.bendover)}/><Link to="" disabled/><br/>
            <Link to="homeEvents.bedTimeTogetherLetHerSpeak"/>
        </Trans>
    </Passage>,

    bedTimeTogetherLetHerSpeak: <Passage>
        <Trans i18nKey="homeEvents.bedTimeTogetherLetHerSpeak">
            1<h1/><Image src={images.wife.actions.bedTime.couple}/><br/>
            <Link to="" callback={()=>{addTimePart(true); currentPlayer.goTo(places.homeBedroom.id);}}/>
        </Trans>
    </Passage>,

    walkTime: <Passage>
        <Trans i18nKey="homeEvents.walkTime.header">1<h1/></Trans>
        <V callback={()=>{
            if (!(conditions.isEvening() && conditions.isStartOfDayPart()))
                currentPlayer.goTo(places.homeBedroom.id)
        }}/>
        <V callback={()=>{
            if (people.wife.relations <= constants.wife.relationsTo.homeEvents)
                return (
                    <div>
                        <Trans i18nKey="homeEvents.walkTime.body">
                            1<Name who={people.wife}/><Image src={images.wife.actions.walkTime.dressingUp}/>
                            <Say who={people.player}/><Say who={people.wife}/><Image src={images.wife.actions.walkTime.walkSep}/>
                            <div style={{color: "red"}}/><br/>
                            <Link to="" callback={()=>{
                                addTimePart(true);
                                addTimePart(true);
                                currentPlayer.goTo(places.homeBedroom.id);}}/>{{wife: people.wife.name}}
                        </Trans>
                    </div>
                )
            else
                jumpTo("homeEvents.walkTimeTogether")
        }}/>
    </Passage>,
    walkTimeTogether: <Passage>
        <Trans i18nKey="homeEvents.walkTimeTogether">
            1<h1/><Name who={people.wife}/><Image src={images.wife.actions.walkTime.dressingUp}/>
            <Say who={people.wife}/><Say who={people.player}/><Image src={images.wife.actions.walkTime.walkTogether}/>
            <Image src={getRandomImage(images.wife.actions.walkTime.woman)}/><Name who={people.wife} nickname/>
            <div style={{color: "red"}}/><br/>
            <Link to="" callback={()=>{
                addTimePart(true);
                addTimePart(true);
                currentPlayer.goTo(places.homeBedroom.id);
            }}/>{{player: people.player.name, wife: people.wife.name}}
        </Trans>
    </Passage>,

    cookingTime: <Passage>
        <Trans i18nKey="homeEvents.cookingTime.header">1<h1/></Trans>
        <V callback={()=>{
            if (!(conditions.isEvening() && conditions.isStartOfDayPart()))
                currentPlayer.goTo(places.homeBedroom.id)
        }}/>
        <V callback={()=>{
            if (people.wife.relations <= constants.wife.relationsTo.homeEvents)
                return (
                    <div>
                        <Trans i18nKey="homeEvents.cookingTime.body">
                            1<Name who={people.wife}/><Say who={people.player}/><Say who={people.wife}/>
                            <Image src={images.wife.actions.cookingTime.wife}/><div style={{color: "red"}}/><br/>
                            <Link to="" callback={()=>{addTimePart(true); currentPlayer.goTo(places.homeKitchen.id);}}/>
                            {{wife: people.wife.name}}
                        </Trans>
                    </div>
                )
            else
                jumpTo("homeEvents.cookingTimeTogether")
        }}/>
    </Passage>,

    cookingTimeTogether: <Passage>
        <Trans i18nKey="homeEvents.cookingTimeTogether">
            1<h1/><Name who={people.wife}/><Say who={people.wife}/><Say who={people.player}/>
            <Image src={images.wife.actions.cookingTime.together}/>
            <Image src={getRandomImage(images.wife.actions.cookingTime.shorts)}/><Name who={people.wife} nickname/>
            <div style={{color: "red"}}/><br/>
            <Link to="" callback={()=>{
                addTimePart(true);
                addTimePart(true);
                currentPlayer.goTo(places.homeBedroom.id);}}/>{{player: people.player.name}}
        </Trans>
    </Passage>,

    dressingTime: <Passage>
        <Trans i18nKey="homeEvents.dressingTime.header">1<h1/></Trans>
        <V callback={()=>{
            if (people.wife.relations <= constants.wife.relationsTo.homeEvents)
                return (
                    <div>
                        <Trans i18nKey="homeEvents.dressingTime.body">
                            1<Name who={people.wife}/><Image src={images.wife.actions.dressingTime.getOut}/>
                            <Say who={people.wife}/><Say who={people.player}/><br/><div style={{color: "red"}}/>
                            <Link to="" callback={()=>{currentPlayer.goTo(places.homeBedroom.id);}}/>
                            {{wife: people.wife.name, player: people.player.name}}
                        </Trans>
                    </div>
                )
            else
                jumpTo("homeEvents.dressingTimeWatch")
        }}/>
    </Passage>,
    dressingTimeWatch: <Passage>
        <Trans i18nKey="homeEvents.dressingTimeWatch">
            1<h1/><Name who={people.wife}/><Image src={getRandomImage(images.wife.actions.dressingTime.dressing)}/>
            <div style={{color: "red"}}/><br/>
            <Link to="" callback={()=>{currentPlayer.goTo(places.homeKitchen.id);}}/>
        </Trans>
    </Passage>
}, "homeEvents");